import classNames from 'classnames';
import isArray from 'lodash-es/isArray';
import isString from 'lodash-es/isString';

import useFormatImageUrl from '../../hooks/useFormatImageUrl';
import { getImageUrl } from '../../lib/getImageSize';

import Image from './Image';

import styles from '../../styles/partials/background.module.css';

export interface BackgroundProps {
    color?: string | null;
    image?: Image | null;
    imageRepeat?: boolean;
    imageFade?: boolean | string | string[] | null;
    imageFadeOpacity?: number;
    imagePosition?: string | null;
    imageSize?: string | null;
    gradient?: string[] | null;
    className?: string | null;
    imageClassName?: string | null;
    pictureClassName?: string | null;
}

const Background = ({
    color = null,
    image = null,
    imageRepeat = false,
    imageFade = false,
    imageFadeOpacity = 0.8,
    imagePosition = null,
    imageSize = 'responsive',
    gradient = null,
    className = null,
    imageClassName = null,
    pictureClassName = null,
}: BackgroundProps) => {
    const formatImageUrl = useFormatImageUrl();
    const imageUrl = formatImageUrl(getImageUrl(image, imageSize));
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.imageRepeat]: imageRepeat,
                },
                className,
            ])}
            style={
                gradient !== null
                    ? {
                          backgroundImage:
                              imageUrl !== null
                                  ? `linear-gradient(${gradient.join(',')}), url("${imageUrl}")`
                                  : `linear-gradient(${gradient.join(',')})`,
                          backgroundSize: 'cover',
                      }
                    : {
                          background: color,
                          backgroundImage: imageRepeat ? `url(${imageUrl})` : null,
                      }
            }
        >
            {imageFade !== null && imageFade !== false ? (
                <div
                    className={styles.fade}
                    style={{
                        opacity: imageFadeOpacity,
                        ...(isString(imageFade)
                            ? {
                                  backgroundColor: imageFade,
                              }
                            : null),
                        ...(isArray(imageFade)
                            ? {
                                  background: `linear-gradient(top bottom, ${imageFade.join(',')})`,
                              }
                            : null),
                    }}
                />
            ) : null}
            {image !== null && !imageRepeat && gradient === null ? (
                <Image
                    className={classNames([styles.image, imageClassName])}
                    pictureClassName={pictureClassName}
                    media={image}
                    position={imagePosition}
                    size={imageSize}
                />
            ) : null}
        </div>
    );
};

export default Background;
